module.exports = __webpack_public_path__ + "img/2afe31c.png";